<template>
  <div v-if="showTree">
    <vs-button color="primary" @click="addNode" type="border">Add Catalog</vs-button>
    <vs-list>
    <vue-tree-list
      @click="onClick"
      @change-name="onChangeName"
      @delete-node="onDel"
      @add-node="onAddNode"
      :model="data"
      default-tree-node-name="new node"
      default-leaf-node-name="new leaf"
      v-bind:default-expanded="false"
    >

      <template v-slot:leafNameDisplay="slotProps">
        <vs-list-header icon-pack="feather" :icon="(slotProps.model.children && slotProps.model.children.length > 0 && !slotProps.expanded) ? 'icon-folder' : ''" :title="slotProps.model.name">{{ slotProps.model.name }} </vs-list-header>
      </template>
      <template v-slot:editNodeIcon="slotProps">
        <span class="icon"></span>
      </template>

      <template v-slot:leafNodeIcon="slotProps">
        <span class="icon">🍃</span>
      </template>
      <template v-slot:treeNodeIcon="slotProps">
        <!-- <span class="icon">{{ (slotProps.model.children && slotProps.model.children.length > 0 && !slotProps.expanded) ? '🌲' : '' }}</span> -->
      </template>
      <span class="icon" slot="addTreeNodeIcon">📂</span>
      <span class="icon" slot="addLeafNodeIcon">➕</span>
      <span class="icon" slot="editNodeIcon">📃</span>
      <span class="icon" slot="delNodeIcon">❌</span>
      <span class="icon" slot="leafNodeIcon">🍃</span>
      <span class="icon" slot="treeNodeIcon">🌲</span>
    </vue-tree-list>
    </vs-list>
    <!-- <button @click="getNewTree">Get new tree</button>
    <pre>
      {{newTree}}
    </pre> -->
    <vs-prompt
      @cancel="clearValMultiple"
      @accept="acceptAlert"
      @close="close"
      :is-valid="validName"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        Enter your Name and Link of <b>Catalog</b>
      <vs-input placeholder="Name RU" v-model="valMultipe.value1" class="mt-4 mb-2 w-full" />
      <vs-input placeholder="Name UZ" v-model="valMultipe.value3" class="mt-4 mb-2 w-full" />
      <vs-input placeholder="Link" v-model="valMultipe.value2" class="w-full" />

      <vs-alert v-if="!validName" color="danger" vs-icon="new_releases" >
        Name Fields can not be empty please enter the data
      </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
  export default {
    components: {
      VueTreeList
    },
    data() {
      return {
        newTree: {},
        data: {},
        showTree: false,
        activePrompt: false,
        valMultipe: {
          value1:'',
          value2:'',
          value3:''
        },
        checkNames: false
      }
    },
    computed:{
      validName(){
        return !this.valMultipe.value1 || (this.valMultipe.value1.length > 0 && this.valMultipe.value3.length > 0)
      }
    },
    created() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.AppActiveUser.scjw
    },
    async mounted() {
      await this.renderData()
    },
    methods: {
      async renderData() {
        this.showTree = false
        let data = (await this.$http.get(`https://tez.public.uz/fserver/getCatalogsTree`)).data
        this.data = new Tree(data)
        this.showTree = true
      },
      async acceptAlert(){
        console.log(this.valMultipe)
        if (this.valMultipe.value1.length > 0 && this.valMultipe.value3.length > 0) {
          let dataForm = {
            name_RU: this.valMultipe.value1,
            name_UZ: this.valMultipe.value3,
            url: this.valMultipe.value2
          }
          if (this.valMultipe.botid) {
            await this.$http.post(`https://tez.public.uz/fserver/updateRow/Botcatalogs/${this.valMultipe.id}`, dataForm).then(response => {
              console.log(response)
              this.renderData()
              this.$vs.notify({
                color:'success',
                title:'Saved',
                text:'The Changes are saved'
              })
            })    
          } else {
            dataForm['section'] = this.valMultipe.isLeaf?1:0
            dataForm['parid'] = this.valMultipe.pid
            dataForm['botid'] = this.$store.state.AppActiveUser.botId
            await this.$http.post(`https://tez.public.uz/fserver/insertRow/Botcatalogs/`, dataForm).then(response => {
              console.log(response)
              this.renderData()
              this.$vs.notify({
                color:'success',
                title:'Saved',
                text:'The Changes are saved'
              })
            })
          }
        } else {
          this.checkNames = true
        }
      },
      close(){
        this.$vs.notify({
          color:'danger',
          title:'Closed',
          text:'You close a dialog!'
        })
      },
      clearValMultiple() {
        this.valMultipe.value1 = "";
        this.valMultipe.value2 = "";
      },
      async deleteData(name, id) {
        if (confirm(`Are you sure to delete ${name}?`)) {
          // this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
          try {
            let obj = {}
            obj['table'] = 'Botcatalogs'
            obj['id'] = id
            await this.$http.post(`https://tez.public.uz/fserver/deleteRow/Botcatalogs/`, obj).then(response => {
              console.log(response)
            })
            await this.$vs.notify({
              title:'Success',
              text:'The data has been deleted!',
              color:'success',
              position:'top-right'
            })
          } catch (error) {
            this.$vs.notify({
              title:'Danger',
              text:'The data has not been deleted!' + error,
              color:'danger',
              position:'top-right'
            })
          }
        }
      },
      onDel(node) {
        console.log(node)
        this.deleteData(node.name, node.id).then(() => {
          node.remove()
          this.renderData()
        })
      },

      onChangeName(params) {
        console.log(params)
      },

      onAddNode(params) {
        console.log(params)
        this.valMultipe = params
        this.valMultipe.value1 = params.name_RU?params.name_RU:''
        this.valMultipe.value3 = params.name_UZ?params.name_UZ:''
        this.valMultipe.value2 = params.url?params.url:''
      },

      onClick(params) {
        this.valMultipe = params
        this.valMultipe.value1 = params.name_RU?params.name_RU:''
        this.valMultipe.value3 = params.name_UZ?params.name_UZ:''
        this.valMultipe.value2 = params.url?params.url:''
        this.activePrompt = true
        console.log(this.valMultipe)
      },

      addNode() {
        var node = new TreeNode({ name: 'new node', isLeaf: false })
        this.valMultipe = node
        this.valMultipe.value1 = node.name_RU?node.name_RU:''
        this.valMultipe.value3 = node.name_UZ?node.name_UZ:''
        this.valMultipe.value2 = node.url?node.url:''
        if (!this.data.children) this.data.children = []
        this.data.addChildren(node)
        console.log(node)
      },

      getNewTree() {
        var vm = this
        function _dfs(oldNode) {
          var newNode = {}

          for (var k in oldNode) {
            if (k !== 'children' && k !== 'parent') {
              newNode[k] = oldNode[k]
            }
          }

          if (oldNode.children && oldNode.children.length > 0) {
            newNode.children = []
            for (var i = 0, len = oldNode.children.length; i < len; i++) {
              newNode.children.push(_dfs(oldNode.children[i]))
            }
          }
          return newNode
        }

        vm.newTree = _dfs(vm.data)
      }
    }
  }
</script>


<style scoped>
  .vtl-icon-folder:before {
    display: none;
  }
  .icon {
    &:hover {
      cursor: pointer;
    }
  }

  .muted {
    color: gray;
    font-size: 80%;
  }
</style>